import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ConciliacaoEnqueueResult {
  requestId?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConciliacaoFornecedoresService {
  private readonly baseUrl = `${environment.apiUrl}${environment.versionApi}/conciliacao`;

  constructor(private readonly http: HttpClient) { }

  enfileirarConciliacao(
    planilha: File,
    codiEmp?: string,
    contaFornecedores?: string
  ): Observable<ConciliacaoEnqueueResult> {
    const formData = new FormData();
    formData.append('planilha', planilha, planilha.name);

    const params: string[] = [];
    if (codiEmp?.trim()) {
      params.push(`codiEmp=${encodeURIComponent(codiEmp.trim())}`);
    }
    if (contaFornecedores?.trim()) {
      params.push(`contaFornecedores=${encodeURIComponent(contaFornecedores.trim())}`);
    }

    const query = params.length ? `?${params.join('&')}` : '';
    return this.http.post<ConciliacaoEnqueueResult>(
      `${this.baseUrl}/contas-pagar${query}`,
      formData
    );
  }
}
